export const TEMPLATE_NAMES = Object.freeze({
  PFIZER_FREE_DRUG: "pfizer-free-drug",
  GENENTECH_COPAY: "genentech-copay",
  GENENTECH_FREE_DRUG: "genentech-free-drug",
  PFIZER_COPAY_ORAL: "pfizer-copay-oral",
  PFIZER_COPAY_ORAL_IQVIA: "pfizer-copay-oral-iqvia",
  PFIZER_COPAY_IV: "pfizer-copay-iv",
  EAGLE_PEMFEXY: "eagle-pemfexy",
  NOVARTIS_COPAY: "novartis-copay",
  BMS_COPAY: "bms-copay",
  BMS_COPAY_LS: "bms-copay-ls",
  REGENERON_COPAY: "regeneron-copay",
  REGENERON_PAP: "regeneron-pap",
  PFIZER_FREE_DRUG_SONNEXUS: "pfizer-free-drug-sonnexus",
  LILLY_COPAY: "lilly-copay",
  LILLY_COPAY_SIGNATURE: "lilly-copay-signature",
  TEVA_COPAY: "teva-copay",
  GSK_COPAY: "gsk-copay"
});

// Templates that display "--" instead of "Indefinitely" when an enrollment has no expiration date.
const TEMPLATES_HIDING_INDEFINITE_VALID_THROUGH = [TEMPLATE_NAMES.BMS_COPAY, TEMPLATE_NAMES.BMS_COPAY_LS];

export const hidesIndefiniteValidThrough = (templateName) =>
  TEMPLATES_HIDING_INDEFINITE_VALID_THROUGH.includes(templateName);

// Templates whose EE submission-failure dialog shows only "Please Contact Support at <email>"
// (no "please try to resubmit" copy, no vendor support phone block).
const TEMPLATES_WITH_SUPPORT_ONLY_FAILURE_MESSAGE = [TEMPLATE_NAMES.BMS_COPAY_LS];

export const usesSupportOnlyFailureMessage = (templateName) =>
  TEMPLATES_WITH_SUPPORT_ONLY_FAILURE_MESSAGE.includes(templateName);

// Templates whose EE submission-failure header omits the drug name
// (renders "Application Submission Failed" instead of "Application Submission Failed For Drug <name>").
const TEMPLATES_HIDING_DRUG_NAME_IN_FAILURE_HEADER = [TEMPLATE_NAMES.BMS_COPAY_LS];

export const hidesDrugNameInFailureHeader = (templateName) =>
  TEMPLATES_HIDING_DRUG_NAME_IN_FAILURE_HEADER.includes(templateName);
